import React, { useEffect, useState } from 'react';
import MUIDataTable from 'mui-datatables';

// Material Resources
import { IconButton, Tooltip, Typography, TableCell } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

// GraphQl
import { useQuery, useMutation } from '@apollo/react-hooks';

// Components & Others
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import CustomOptions from '../../../CustomOptions';
import LoadingIndicator from '../../../LoadingIndicator';
import { LIST_CONTRACT_TYPES, DELETE_CONTRACT_TYPE } from '../queries';

import {
  edgeToList,
  generateColumn,
  errorMessage,
  getOptions,
} from '../../../../utils/commonFunctions';
import { textLabels } from '../../../../translations/components/MUIDataTable';
import { CONDITIONS } from '../ContractForm/constants';

// Styles & Images
import useStyles from './styles';

function ContractList() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [contractTypeList, setContractTypeList] = useState([]);

  const classes = useStyles();

  const [deleteContractType] = useMutation(
    DELETE_CONTRACT_TYPE,
    getOptions({
      mutationName: 'deleteContractType',
      modelName: 'contractType',
      message: 'Tipo de contrato eliminado con éxito.',
      enqueueSnackbar,
      refetchQueries: [{ query: LIST_CONTRACT_TYPES }],
    })
  );

  const { loading, error, data } = useQuery(LIST_CONTRACT_TYPES);
  if (error) {
    errorMessage(
      'Error al obtener la lista de tipos de contrato',
      enqueueSnackbar
    );
  }
  useEffect(() => {
    if (data) {
      setContractTypeList(edgeToList(data, 'listContractType'));
    }
  }, [data]);

  const columns = [
    generateColumn('Nombre', 'name'),
    generateColumn('Estado civil', 'condition', {
      sort: true,
      filter: false,
      customBodyRender: value => CONDITIONS.find(c => c.value === value).label,
    }),
    generateColumn('Fondo ', 'fund', {
      sort: true,
      filter: false,
      customBodyRender: value => (value ? value.businessName : '-'),
    }),
  ];
  columns.push({
    name: 'id',
    label: 'Opciones',
    options: {
      sort: false,
      customBodyRender: value => {
        const id = value;
        return (
          <CustomOptions
            id={id}
            model="Tipo de Contrato"
            options={['odelete']}
            handleDelete={() => {
              deleteContractType({ variables: { id } });
            }}
          />
        );
      },
      customHeadRender: columnMeta => {
        return (
          <TableCell key={4} style={{ borderBottom: 'none' }}>
            <Typography
              variant="subtitle1"
              align="left"
              className={classes.tableTitle}
            >
              {columnMeta.label}
            </Typography>
          </TableCell>
        );
      },
    },
  });

  const handleRowClick = (rowData, rowMeta) => {
    if (rowData[rowData.length - 1] && rowData[rowData.length - 1].props) {
      history.push(
        `${history.location.pathname}/${rowData[rowData.length - 1].props.id}`
      );
    }
  };

  const options = {
    filterType: false,
    responsive: 'standard',
    selectableRows: 'none',
    print: false,
    filter: false,
    download: false,
    search: false,
    viewColumns: false,
    textLabels,
    customToolbar: () => {
      const handleClick = () => {
        history.push(`/administrador/tipos-de-contrato/crear`);
      };
      return (
        <Tooltip title="Nuevo Levantamiento">
          <IconButton color="secondary" onClick={handleClick}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      );
    },
    onRowClick: rowData => handleRowClick(rowData),
  };

  return (
    <>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <MUIDataTable
          title="Tipos de contrato"
          data={contractTypeList}
          columns={columns}
          options={options}
        />
      )}
    </>
  );
}

export default ContractList;
